import script from "./PlanHome.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanHome.vue?vue&type=script&setup=true&lang=js"

import "./PlanHome.vue?vue&type=style&index=0&id=2c40077c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c40077c"]])

export default __exports__